"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const LoadingSpinner_1 = __importDefault(require("../../common/js/components/LoadingSpinner"));
const Downloads_1 = __importDefault(require("../stores/Downloads"));
const UiStore_1 = __importDefault(require("../stores/UiStore"));
const SoftwareDownloadsTabs_1 = __importDefault(require("./SoftwareDownloadsTabs"));
class SoftwareDownloads extends react_1.default.Component {
    categories = [];
    isLoading = true;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            categories: mobx_1.observable,
            isLoading: mobx_1.observable,
        });
    }
    componentDidMount() {
        const { software } = this.props;
        Downloads_1.default.loadSoftwareMedia(software, UiStore_1.default.language)
            .then((softwareMediaCategories) => {
            this.categories = softwareMediaCategories ?? [];
        })
            .finally((0, mobx_1.action)(() => {
            this.isLoading = false;
        }));
    }
    render() {
        const { software } = this.props;
        if (this.isLoading) {
            return (react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                react_1.default.createElement(LoadingSpinner_1.default, null)));
        }
        if (this.categories.length > 0) {
            return react_1.default.createElement(SoftwareDownloadsTabs_1.default, { software: software, categories: this.categories });
        }
        return null;
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(SoftwareDownloads));
